import { ParkingType } from '../store/offer';

export const ParkingTypeNames = {
  [ParkingType.Ground]: 'Наземная',
  [ParkingType.Multilevel]: 'Многоуровневая',
  [ParkingType.Open]: 'Открытая',
  [ParkingType.Roof]: 'На крыше',
  [ParkingType.Spontaneous]: 'Спонтанная',
  [ParkingType.Underground]: 'Подземная',
};
